/**
 * The class Mixpanel's session replay blocks by default (its
 * `record_block_class`, which the app does not override): an element with it
 * is recorded as an empty box of the same size, and nothing inside it is
 * captured. Direct messages are private, so everything that shows one carries
 * it: the Messages view's root, and any overlay that renders outside the view
 * with DM content in it.
 *
 * Typed text needs nothing extra: the recorder masks every input.
 */
export const REPLAY_BLOCK_CLASS = 'mp-block'
